<template>
    <!-- Main Wrapper -->
    <div class="main-wrapper">
        <layouts></layouts>
        <sidebar-menu></sidebar-menu>
        <div class="page-wrapper">
            <div class="content">
                <pageaddheader :title="title" :title1="title1" :items="items" />
                <div class="alert alert-warning" v-if="appActive">
                    Connected Apps sedang aktif. Mesin baru tidak bisa ditambahkan sebelum Connected Apps dinonaktifkan.
                </div>
                <!-- /product list -->
                <div class="card">
                    <div class="card-body pt-1">
                        <div class="table-top d-flex justify-content-start gap-2">
                            
                            <div class="search-set " style="margin-top: 10px !important; margin-bottom: 0px !important;">
                                <div class="search-input">
                                    <a class="btn btn-searchset"><img src="@/assets/img/icons/search-white.svg"
                                            alt="img" /></a>
                                    <div id="DataTables_Table_0_filter" class="dataTables_filter">
                                        <label>
                                            <input type="search" class="form-control form-control-sm"
                                                placeholder="Search..." aria-controls="DataTables_Table_0"
                                                v-model="query" />
                                        </label>
                                    </div>
                                </div>
                            </div>

                            
                            
                        

                        </div>

                        <div class="table-responsive mt-0">
                            <a-table :columns="columns" :data-source="filteredData" @change="handleTableChange" :pagination="pagination" :loading="loading">
                                <template #bodyCell="{ column, record }">
                                    <template v-if="column.key === 'no'">
                                        {{ record.no }}
                                    </template>
                                    

                                    <template v-else-if="column.key === 'tipe'">
                                        {{ Number(record.is_adms) ? 'ADMS' : 'SECURE' }}
                                    </template>
                                    <template v-else-if="column.key === 'action'">
                                        <a href="#" class="me-3" @click.prevent="edit(record)" style="cursor:pointer; color:#637381">
                                            <img src="@/assets/img/icons/edit.svg" alt="img" />
                                        </a>
                                        <a class="confirm-text" href="javascript:void(0);"
                                            @click="terminate(record.id); showModal('terminate');">
                                            <img src="@/assets/img/icons/delete.svg" alt="img" />
                                        </a>
                                    </template>
                                </template>
                            </a-table>
                        </div>
                    </div>
                </div>
                <!-- /product list -->
            </div>
        </div>
    </div>
   
    <div class="modal fade" id="terminate" ref="terminate" tabindex="-1" role="dialog"
        aria-labelledby="exampleModalCenterTitle" aria-hidden="true">
        <div class="modal-dialog modal-dialog-centered" role="document">
            <div class="modal-content">
                <div class="modal-header">
                    <h5 class="modal-title" id="exampleModalLongTitle">Delete Device</h5>
                    <button type="button" class="close" @click="hideModal2('terminate')" aria-label="Close">
                        <span aria-hidden="true">&times;</span>
                    </button>
                </div>
                <form @submit.prevent="delete2">
                    <div class="modal-body">
                        Are u sure want to delete this device?
                    </div>
                    <div class="modal-footer d-flex justify-content-end">
                        <button type="button" class="btn  btn-secondary"
                            @click="hideModal2('terminate')">cancel</button>
                        <button type="submit" class="btn  btn-danger">Delete</button>
                    </div>
                </form>
            </div>
        </div>
    </div>
</template>
<script>

import Cookies from "js-cookie";
import axios from "axios";
import { watch } from "vue";
import { base_url, AlertPopup2, AlertBottom, appendForm, timeout, selectedBranch, goPage } from "@/assets/js/function";


import DatePicker from 'vue-datepicker-next'
import 'vue-datepicker-next/index.css'


export default {
    components: {
        DatePicker
    },
    data() {
        return {
            filter: false,
            title: "Devices List",
            title1: "Manage devices",
            items: [
                {
                    text: "Add Devices",
                    addname: "/adddevices",
                },
            ],
            periode: [],
            data: [],
            columns: [
                {
                    title: "No",
                    dataIndex: "no",
                    key: "no",
                    sorter: {
                        compare: (a, b) => {
                            a = a.no.toLowerCase();
                            b = b.no.toLowerCase();
                            return a > b ? -1 : b > a ? 1 : 0;
                        },
                    },
                },
                {
                    title: "Serial Number",
                    dataIndex: "sn",
                    key: "sn",
                    sorter: {
                        compare: (a, b) => {
                            a = a.sn.toLowerCase();
                            b = b.sn.toLowerCase();
                            return a > b ? -1 : b > a ? 1 : 0;
                        },
                    },
                },
                
                {
                    title: "Nama",
                    dataIndex: "nama",
                    key: "nama",
                    sorter: false,
                },
                {
                    title: "Tipe",
                    key: "tipe",
                    sorter: false,
                },
                {
                    title: "Action",
                    key: "action",
                    sorter: false,
                },
            ],

            tanggal_terminate: "",
            alasan_terminate: "",
            id_terminate: "",
            nama_terminate: "",

            pagination: {
                current: 1,
                pageSize: 10,
                showSizeChanger: false
            },

            loading: false,
            appActive: false,

            //filter
            query: "",
        };
    },
    created() {
        const token = Cookies.get("token_refresh");
        this.config = {
            headers: { Authorization: `Bearer ` + token },
            timeout: 30000,
        }
        
        const branch = parseInt(localStorage.getItem("selectedBranch")) || 0;

        //Update local and shared state
        this.filter = branch;
        selectedBranch.value = branch;

        localStorage.setItem('actionState', 'view')

        const now = new Date();
        const year = now.getFullYear();
        const month = now.getMonth(); // zero-based
        const start = new Date(year, month, 1);
        const end = new Date(year, month + 1, 0);
        this.periode = [
            this.formatDateLocal(start),
            this.formatDateLocal(end),
        ];
        this.index();
    },

    mounted() {

        watch(selectedBranch, () => {
            this.index()
        }, { immediate: true })

        const savedPage = localStorage.getItem("lastPage");
        if (savedPage) {
            this.pagination.current = parseInt(savedPage);
        }
    },

    computed: {
        filteredData() {
            // Filter data based on selected jenis_kehadiran
            if (this.query == '') {
                return this.data; // If no filter selected, return all data
            }
            const lowerCaseQuery = this.query.toLowerCase(); // Optional: Convert to lowercase for case-insensitive comparison
            return this.data.filter(item =>
                item.sn.toLowerCase().includes(lowerCaseQuery) 
            );
        }
    },
    methods: {
      
        showModal(modal_name) {
            this.$refs[modal_name].classList.add('show');
            this.$refs[modal_name].style.display = 'block';
        },
        hideModal2(modal_name) {
            this.$refs[modal_name].classList.remove('show');
            this.$refs[modal_name].style.display = 'none';
        },

        handleTableChange(pagination) {
            this.pagination = pagination; // keep pagination reactive
            localStorage.setItem("lastPage", pagination.current);
        },

        formatDateLocal(date) {
            const year = date.getFullYear();
            const month = String(date.getMonth() + 1).padStart(2, "0"); // Month is 0-based
            const day = String(date.getDate()).padStart(2, "0");
            return `${year}-${month}-${day}`;
        },
        addNumberToObjects(objArray) {
            for (let i = 0; i < objArray.length; i++) {
                const newObj = { No: i + 1, ...objArray[i] };
                objArray[i] = newObj;
            }
            return objArray;
        },
        async export_overtime() {
           
            let formData = new FormData();
            appendForm(formData)

            if (this.periode && this.periode.length === 2) {
                const [startDate, endDate] = this.periode;
                formData.append("dfrom",  startDate);  // end date
                formData.append("dto", endDate);  // start date
            }
            for (let [key, value] of formData.entries()) {
                console.log(key, value);
            }
            // CloseLoading()
            // return true

            const api = base_url + '/v3/overtime/export';
            const res = await axios.post(api, formData, { timeout });
            const data = res.data;
        
            console.log('ini data overtime:', data)

            if(data.status){
                const fileUrl = data.data.file_report;

                if (!this.periode) {
                    console.error("Error: this.periode is undefined or null");
                    return;
                }

                if (!fileUrl) {
                    // console.error("Error: file_report URL is missing!");
                    AlertPopup2("error", "", "Download link not found", true, 1500);
                    
                }

                
                const link = document.createElement("a");
                link.href = fileUrl;
                link.setAttribute("download", "Overtime.xlsx"); // You can change the filename
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);
                
            }else {
                AlertPopup2("error", "", data.message, true, 1500);
            }

            

        },

        shortenDescription(description) {
            if (description.length > 35) {
                return description.substring(0, 35) + '...';
            } else {
                return description;
            }
        },
        onDateChange(value) {
            this.periode = value;
            this.index();
        },
        // openNewTab(record) {
        //     localStorage.setItem("overtimeData", JSON.stringify(record));
        //     window.open("/editovertime", "_blank");
        // },

        async index() {
            this.loading = true;

            let formData = new FormData();
            appendForm(formData)

            // Ensure periode has both start and end dates
            if (this.periode && this.periode.length === 2) {
                const [startDate, endDate] = this.periode;
                formData.append("dfrom",  startDate);  // end date
                formData.append("dto", endDate);  // start date
            }
            
            for (let [key, value] of formData.entries()) {
                console.log(key, value);
            }
            // CloseLoading()
            // return true

            const api = base_url + '/v3/machine_secure/index';
            const res = await axios.post(api, formData, { timeout });
            const data = res.data;
            console.log('ini data devices:', data)
            
            if(data.status){
                this.data = [];

                const device = data.data.data_machine_secure;
                // Connected Apps aktif = tombol Add Devices disembunyikan
                this.appActive = !!data.data.app_active;
                if (this.appActive) this.items = [];
                // const employees = data.data.data_employees;

                device.forEach((item, index) => {
                    let item_prepare = { ...item, no: (index + 1), };
                    this.data.push(item_prepare);
                });

                this.loading = false;

                
                
            }else {
                AlertPopup2("error", "", data.message, true, 1500);
            }

           

        },
        
        edit(record) {
            localStorage.setItem('currentData', JSON.stringify(record));
            goPage('editdevices')
        },
        
        async delete2() {
            let formData = new FormData();
            appendForm(formData)

            formData.append("id", this.id_terminate);

            const api = base_url + '/v3/machine_secure/delete';
            const res = await axios.post(api, formData, { timeout });
            const data = res.data;
            
            if(data.status){
                const index = this.data.findIndex((record) => record.id === this.id_terminate);
                    this.data.splice(index, 1);
                    AlertBottom(data.message);
                    this.hideModal2('terminate');
                
            }else {
                AlertPopup2("error", "", data.message, true, 1500);
            }

            

        },
        terminate(id) {
            this.id_terminate = id;
        }
    },
    name: "productlist",
};
</script>
<style>
.ant-tooltip {
    display: none !important;
}
</style>